export default "__VITE_ASSET__CUys1jDi__"